<template>
  <div class="region-select">
    <div class="info-control arr-item" @click="showPal">
      <span>{{ labelName }}</span>
      <span style="color: #aaaaaa">{{
        selectIndex >= 0 ? typeList[selectIndex].name : ""
      }}</span>
    </div>
    <div class="region-panel" v-if="isShow">
      <ul class="list" v-if="isShow">
        <li
          class="list-item card-item"
          v-for="(item, index) in typeList"
          @click="checked(index)"
        >
          <i :class="{ icon: selectIndex === index }"></i>
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /* 标签名称 */
    labelName: String,
    /* 类型数组，类似[{ key: '4', name: '居民健康卡' }] */
    typeList: Array,
    // 默认选中项
    defaultSelectIndex: {
      type: Number,
      default: function () {
        return 0;
      }
    },
    // 是否有默认选中项
    hasDefaultSelect: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
  },
  data () {
    return {
      selectIndex: -1,
      isShow: false
    }
  },
  mounted () {
    if (this.hasDefaultSelect) {
      // 默认选中项
      this.selectIndex = this.defaultSelectIndex
      this.$emit('type-select', this.selectIndex)
    }
    window.onpopstate = () => {
      if (this.isShow) {
        this.isShow = false
        history.go(1)
      }
    }
  },
  methods: {
    showPal () {
      this.isShow = true
    },
    checked (index) {
      this.selectIndex = index
      this.$emit('type-select', index)
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.region-select {
  .info-control {
    height: 1rem;
    line-height: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
  }
  .arr-item {
    padding-right: 0.8rem;
  }
  .arr-item:after {
    right: 0;
  }
  .card-item {
    position: relative;
    .icon {
      position: absolute;
      background: url(../../static/img/choice-success.png) no-repeat;
      background-size: 100% 100%;
      right: 0.8rem;
      top: 0.25rem;
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
.region-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 0.6s;
  background-color: #eff3f6;
  overflow: hidden;
  z-index: 9999;
  overflow-y: auto;
  height: 1000px;
}
</style>


// WEBPACK FOOTER //
// TypeSelect.vue?c5cc5e00